__turbopack_context__.v({
  "FLIPSpotlightShadowProductBottom": "header-product-module__eUgWVa__FLIPSpotlightShadowProductBottom",
  "buyAProduct": "header-product-module__eUgWVa__buyAProduct",
  "buyingOptionsNavButtons": "header-product-module__eUgWVa__buyingOptionsNavButtons",
  "flip": "header-product-module__eUgWVa__flip",
  "flipSquare": "header-product-module__eUgWVa__flipSquare",
  "flipTall": "header-product-module__eUgWVa__flipTall",
  "flipWide": "header-product-module__eUgWVa__flipWide",
  "header": "header-product-module__eUgWVa__header",
  "headerBackground": "header-product-module__eUgWVa__headerBackground",
  "headerBackgroundBlur": "header-product-module__eUgWVa__headerBackgroundBlur",
  "headerBackgroundWrapper": "header-product-module__eUgWVa__headerBackgroundWrapper",
  "headerBottomPart": "header-product-module__eUgWVa__headerBottomPart",
  "headerContent": "header-product-module__eUgWVa__headerContent",
  "headerTopPart": "header-product-module__eUgWVa__headerTopPart",
  "heroImage": "header-product-module__eUgWVa__heroImage",
  "heroMedia": "header-product-module__eUgWVa__heroMedia",
  "heroPanel": "header-product-module__eUgWVa__heroPanel",
  "purchaseCard": "header-product-module__eUgWVa__purchaseCard",
  "purchaseEyebrow": "header-product-module__eUgWVa__purchaseEyebrow",
  "purchaseMeta": "header-product-module__eUgWVa__purchaseMeta",
  "spotlightShadowProductBottom": "header-product-module__eUgWVa__spotlightShadowProductBottom",
});
